<div class="files-upload">
    <div [hidden]="!multiple && files.queue.length !== 0">
        <!-- <div class="drag" ng2FileDrop [ngClass]="{'drag--hover': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)" [uploader]="uploader"> -->
        
        <!-- new drop zone https://www.npmjs.com/package/ngx-file-drop -->
        <ngx-file-drop 
            multiple="multiple"
            dropZoneLabel="Drop files here" 
            dropZoneClassName="drag"
            contentClassName="drag-content"
            (onFileDrop)="dropped($event)" 
            (onFileOver)="fileOver($event)" 
            (onFileLeave)="fileLeave($event)">
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                <div (click)="openFileSelector()">
                    <span>Drag files or click here</span>
                </div>
                <!-- <button type="button" (click)="openFileSelector()">Browse Files</button> -->
            </ng-template>
        </ngx-file-drop>
        <!-- /end of new drop zone-->
        <!--  old drop zone
        <div class="drag" [ngClass]="{'drag--hover': hasBaseDropZoneOver}">
            <label for="{{fileInputName}}"><em>Upload your file</em><span>Drag files or click here</span></label>
            <form id="">
                <input *ngIf="!multiple" type="file" name="{{fileInputName}}" id="{{fileInputName}}" (change)="onUploadFiles($event)" #iptFile/>
                <input *ngIf="multiple" type="file" multiple name="{{fileInputName}}" id="{{fileInputName}}" (change)="onUploadFiles($event)" #iptFile />
            </form>
        </div>
        -->
    </div>

    <ul>
        <li class="files-upload-li" *ngFor="let file of files.queue" [hidden]="file.status == 2 && hiddenUploaded">
            <div class="progressbar" *ngIf="file.status == 0" role="progressbar" [ngStyle]="{ 'width.%': file.progress }"><span>Progress bar</span></div>
            <div class="ctn" *ngIf="file.status != 2" [ngClass]="{'complete': file.status == 2, 'fail': file.status == 1}">
                <core-helpers-box-list-item [close]="true" (onCloseClick)="removeFile(file)" [mainText]="getViewName(file)"></core-helpers-box-list-item>
            </div>
            <core-file-uploaded-list-item *ngIf="file.status == 2" [remove]="true" (onRemove)="removeFile(file)" [file]="file.object"></core-file-uploaded-list-item>
        </li>
    </ul>
</div>
